import type { TerminalMessage } from '@/types';

export const terminalLogs: TerminalMessage[] = [
  {
    level: 'SYSTEM',
    text: 'Initializing Vova_v2025_Final_Release...',
    delay: 0,
  },
  {
    level: 'INFO',
    text: 'Current Epoch: 21 -> 22',
    delay: 800,
  },
  {
    level: 'WARN',
    text: 'High load detected: SHAD deadlines, HSE tasks, Gym sessions.',
    delay: 1200,
  },
  {
    level: 'INFO',
    text: 'Optimization Warning: High concentration of Jabronis detected in local cluster.',
    delay: 1800,
  },
  {
    level: 'ERROR',
    text: '[CRITICAL] Boss of This Gym Detected in Local Cluster. Please take it like a man.',
    delay: 2500,
  },
  {
    level: 'INFO',
    text: 'Deep Dark Fantasies module loaded successfully.',
    delay: 3200,
  },
  {
    level: 'SYSTEM',
    text: 'System ready. Awaiting deployment command. (300 bucks fee may apply)',
    delay: 3800,
  },
];
